import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import { BSpinner, BToast, BModal } from 'bootstrap-vue'
import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import pagination from '@/components/layout/pagination/Pagination.vue'
import util from '@/util'
import fileDownload from 'js-file-download'
import mensagens from '@/util/mensagens'
import arquivoUtil from '@/util/arquivoUtil'
import { faturaMixin } from '@/modules/faturas/mixins'
import constants from '@/util/constants'
import { mapState } from 'vuex'
import ModalConfirmacaoCancelamentoFatura from '@/views/faturas/ModalConfirmacaoCancelamentoFatura.vue'
import DetalheFatura from '@/views/faturas/DetalheFatura.vue'

export default {
  name: 'faturaDetalhes',
  components: {
    cabecalho,
    menuLateral,
    pagination,
    spinnerProcessando,
    ModalConfirmacaoCancelamentoFatura,
    DetalheFatura,
    'b-toast': BToast,
    'b-modal': BModal,
    'default-table': defaultTable,
    'b-spinner': BSpinner
  },
  mixins: [faturaMixin],
  computed: {
    ...mapState('auth', ['dadosAlertaDesbloqueio']),
    arrayDadosAlertaDesbloqueio () {
      if (this.dadosAlertaDesbloqueio) {
        const arrayDadosAlertaDesbloqueio = JSON.parse(this.dadosAlertaDesbloqueio)
        return arrayDadosAlertaDesbloqueio
      }
    },
    ehStatusFaturaPaga () {
      return this.detalheFatura.status === constants.statusFatura.cobrancaPaga
    },
    ehStatusFaturaAguardandoConfirmacao () {
      return this.detalheFatura.status === constants.statusFatura.cobrancaAguardandoConfirmacao
    },
    obterCorStatusCredito () {
      const classe = {
        1: 'cobranca-status-credito-pendente',
        2: 'cobranca-status-credito-realizado',
        3: 'cobranca-status-credito-recusado',
        1000: 'cobranca-status-credito-recusado',
        default: 'cobranca-status-credito-pendente'
      }
      return classe[this.detalheFatura.status_id] ?? classe['default']
    },
    obterDescricaoFatura () {
      if (!util.valorVazio(this.detalheFatura.descricao)) {
        return this.detalheFatura.descricao
      }
      return 'Mensalidade'
    },
    obterImagemBandeiraCartao () {
      const filtroPorCodigo = (codigo, bandeira) => bandeira.codigos.includes(codigo)
      const bandeiraEncontrada = this.obterBandeiraCartaoPorFiltro(+this.detalheFatura.bandeira_cartao, filtroPorCodigo)
      if (!bandeiraEncontrada) return null
      return this.obterIconeBandeira(bandeiraEncontrada.nome)
    },
    possuiBandeiraCartao () {
      const bandeiraCartao = this.obterImagemBandeiraCartao
      return bandeiraCartao !== null
    },
    podeCancelarFatura () {
      const statusPermitidosCancelamento = [
        constants.statusPagamento.pendente,
        constants.statusPagamento.erro,
        constants.statusPagamento.recusado,
        constants.statusPagamento.devolvido,
        null
      ]
      return (statusPermitidosCancelamento.includes(this.detalheFatura.status_id)) && !this.ehContratacaoProdutoPrincipal && !this.ehStatusFaturaPaga
    },
    ehContratacaoProdutoPrincipal () {
      return this.itensDaFatura.some(item => item.produto_id === constants.idProdutoMirt)
    },
    estaCarregandoDados () {
      return this.flagsDeControle.carregandoDados.status === true
    }
  },
  data: () => {
    return {
      subTotal: 0,
      desconto: 0,
      cupomSelecionado: null,
      detalheFatura: [],
      itensDaFatura: [],
      confirmarCancelamento: false,
      feedbackLink: false,
      feedbackCodigo: false,
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        },
        desbloqueioEscritorio: {
          status: false,
          mensagem: ''
        }
      }
    }
  },
  async mounted () {
    await this.obterDetalhamentoFatura()
    this.notificarSobreDesbloqueio()
  },
  methods: {
    obterTotalPorPedido (item) {
      if (item.valor === null) {
        return 0
      }
      return item.valor * item.quantidade
    },
    formatarValorMonetario (valor, tipo = constants.tipoMonetario, total) {
      if (util.valorEhNulo(valor)) {
        return 'R$ 0'
      }
      if (tipo === constants.tipoMonetario) {
        return util.formatarValorMonetarioComCifrao(valor)
      } else if (tipo === constants.tipoPercentual) {
        // Converter percentual para valor monetário usando regra de três
        const valorConvertido = (valor / 100) * total
        return util.formatarValorMonetarioComCifrao(valorConvertido)
      }
    },
    async obterDetalhamentoFatura () {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.get(`/manager/conta/faturas/${this.$route.params.id}`)
        if (resposta.data.retorno.dados.detalhes_fatura !== null) {
          this.detalheFatura = resposta.data.retorno.dados.detalhes_fatura
          this.itensDaFatura = resposta.data.retorno.dados.itens
          this.cupomSelecionado = resposta.data.retorno.dados.cupom

          this.itensDaFatura.forEach(item => {
            this.subTotal += this.obterTotalPorPedido(item)

            //  o desconto é o valor total da fatura menos o subtotal
            this.desconto = (this.subTotal - this.detalheFatura.valor_total)
          })
        }
      } catch (e) {
        this.$router.push('/faturas').then(() => util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados))
      }
      this.definirFlagCarregandoDados(false, '')
    },
    async cancelarFaturaPendente () {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.post('/manager/conta/fatura/cancelar', { itens: this.itensDaFatura, detalhes_fatura: this.detalheFatura })
        if (resposta.data.retorno.sucesso) {
          this.$router.push('/faturas').then(() => util.criarAlertaToastDeSucesso(this, 'Aviso', resposta.data.retorno.mensagem))
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', resposta.data.retorno.mensagem)
        }
      } catch (erro) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },
    copiarTexto (idElemento) {
      const elemento = document.getElementById(idElemento)
      const textoSelecionado = window.getSelection()
      const faixa = document.createRange()
      faixa.selectNodeContents(elemento)
      textoSelecionado.removeAllRanges()
      textoSelecionado.addRange(faixa)

      try {
        document.execCommand('copy')
        this[idElemento === 'linkPagamento' ? 'feedbackLink' : 'feedbackCodigo'] = true
        setTimeout(() => {
          this[idElemento === 'linkPagamento' ? 'feedbackLink' : 'feedbackCodigo'] = false
        }, 2000)
      } catch (err) {
        console.error('Erro ao copiar texto: ', err)
      }
    },
    async baixarBoleto (urlBoleto) {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        await arquivoUtil.downloadArquivoUrl(urlBoleto, 'boleto.pdf')
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    async baixarNotaFiscal (idFatura) {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.get(`/manager/conta/fatura/${idFatura}/download/nota_fiscal/xml/configuracao/baixar`, { responseType: 'blob' })
        fileDownload(resposta.data, 'nota_fiscal.xml')
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    async visualizarNotaFiscal (idFatura) {
      const resposta = await this.axios.get(`/manager/conta/fatura/${idFatura}/download/nota_fiscal/pdf/configuracao/visualizar`, { responseType: 'blob' })
      const blob = new Blob([resposta.data], { type: 'application/pdf' })
      const pdfUrl = URL.createObjectURL(blob)

      window.open(pdfUrl, '_blank')
    },
    formatarCartaoCredito (valor) {
      const utlimos4digitos = valor.slice(-4)
      return 'XXXX-XXXX-XXXX-' + utlimos4digitos
    },
    obterDescricaoStatusPagamento (codigoStatus) {
      switch (codigoStatus) {
        case 1:
          return 'Pagamento Pendente'
        case 2:
          return 'Pagamento Realizado'
        case 3:
          return 'Pagamento Recusado'
        case 4:
          return 'Pagamento Devolvido'
        case 1000:
          return 'Falha ao efetuar o pagamento'
        default:
          return 'Falha ao identificar o status do pagamento'
      }
    },
    calcularSubTotalDoItem (quantidade, valorUnitario) {
      valorUnitario = parseFloat(valorUnitario)
      quantidade = parseInt(quantidade)
      const subTotal = valorUnitario * quantidade
      return subTotal
    },

    notificarSobreDesbloqueio () {
      const deveNotificarSobreDesbloqueio = this.arrayDadosAlertaDesbloqueio?.desbloquearEscritorio && this.arrayDadosAlertaDesbloqueio?.idFatura === this.$route.params.id
      if (!deveNotificarSobreDesbloqueio) {
        this.definirFlagDesbloqueioEscritorio(false, '')
        return
      }
      if (this.ehStatusFaturaPaga) {
        this.definirFlagDesbloqueioEscritorio(true, mensagens.desbloqueioEscritorioImediato)
        return
      }

      if (this.ehStatusFaturaAguardandoConfirmacao) {
        this.definirFlagDesbloqueioEscritorio(true, mensagens.desbloqueioEscritorioPosterior)
      }
    },

    definirFlagDesbloqueioEscritorio (status, mensagem) {
      this.flagsDeControle.desbloqueioEscritorio.status = status
      this.flagsDeControle.desbloqueioEscritorio.mensagem = mensagem
    },
    abrirModal () {
      this.confirmarCancelamento = true
    },
    fecharModal () {
      this.confirmarCancelamento = false
    }
  }
}
